import React, { useMemo } from 'react';

import { FormDefinition } from './form-definition/ReportFormDefinition';
import { TableDefinition } from './table-definition/ReportTableDefinition';
import { useAppSelector } from '../../../../hooks/react-redux';
import { useWindowResize } from '../../../../hooks/useWindowResize';
import { DatasetDefinition } from '../../../datasets/store/types';
import { isFormDatasetDefinition } from '../../../datasets/store/typeAssertions';
import { getClientHiddenFields, getDocumentSpecificHiddenFields } from '../store';

interface ReportDatasetDefinitionProps {
    datasetDefinition: DatasetDefinition;
    parents: number;
    datasetHidden?: boolean;
    parentHiddenDocumentNameIds?: number[];
    parentFieldId: string;
}

export const ReportDatasetDefinition: React.FC<ReportDatasetDefinitionProps> = ({ datasetDefinition, parents, datasetHidden, parentHiddenDocumentNameIds, parentFieldId }) => {
    const [screenWidth] = useWindowResize();
    const padding = parents > 0 ? 10 : 0;
    const width = (screenWidth - 60) - (parents * 10);
    const hiddenFields = useAppSelector(getClientHiddenFields);
    const documentSpecificHiddenFields = useAppSelector(getDocumentSpecificHiddenFields);

    const definitionComponent = useMemo(() => {
        if (isFormDatasetDefinition(datasetDefinition)) {
            return (<FormDefinition formDefinition={datasetDefinition} parents={parents} hiddenFields={hiddenFields} datasetHidden={datasetHidden} documentSpecificHiddenFields={documentSpecificHiddenFields} parentHiddenDocumentNameIds={parentHiddenDocumentNameIds} parentFieldId={parentFieldId} />);
        }
        return (<TableDefinition tableDefinition={datasetDefinition} hiddenFields={hiddenFields} datasetHidden={datasetHidden} documentSpecificHiddenFields={documentSpecificHiddenFields} parentHiddenDocumentNameIds={parentHiddenDocumentNameIds} parentFieldId={parentFieldId} />);
    }, [datasetDefinition, parents, hiddenFields, datasetHidden, documentSpecificHiddenFields, parentHiddenDocumentNameIds, parentFieldId]);

    return (
        <div style={{ paddingLeft: `${padding}px`, width: `${width}px`, maxWidth: `${screenWidth}px`, height: '100%' }}>
            {definitionComponent}
        </div>
    );
};
